var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "deeplinkresult px-0" },
    [
      _c("div", { staticClass: "bg-white w-100 p-2 mb-4" }),
      _vm.deepLinkAdvert !== undefined && _vm.deepLinkAdvert.length > 0
        ? _c("JobViewContainer", {
            attrs: {
              jobPostings: _vm.deepLinkAdvert,
              isSearching: false,
              useSavedAdvert: true,
              selectedJobPosting: _vm.selectedJobPosting,
              activeIndex: 0,
            },
            on: {
              setSelectedJobPosting: function ($event) {
                return _vm.setSelectedJobPosting($event)
              },
            },
          })
        : _c(
            "div",
            { staticClass: "no-advert flex-column d-flex align-items-center" },
            [
              _c(
                "div",
                { staticClass: "brand bottom-border mb-5 text-center" },
                [
                  !_vm.isMobile
                    ? _c("h2", { staticClass: "font-weight-bold pb-3" }, [
                        _vm._v(_vm._s(_vm.content.noAdvert)),
                      ])
                    : _c("h4", { staticClass: "font-weight-bold pb-3" }, [
                        _vm._v(_vm._s(_vm.content.noAdvert)),
                      ]),
                ]
              ),
            ]
          ),
      _vm.selectedJobPosting !== undefined
        ? _c("MobileButtonBottom", {
            attrs: {
              selectedJobPosting: _vm.selectedJobPosting,
              mobileFilterIsActive: false,
              content: undefined,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }